import { cn } from '@/lib/utils';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/components/ui/avatar';
import type { ComponentProps, HTMLAttributes, ReactNode } from 'react';

export type AIMessageProps = HTMLAttributes<HTMLDivElement> & {
  from: 'user' | 'assistant';
};

export const AIMessage = ({ className, from, ...props }: AIMessageProps) => (
  <div
    className={cn(
      'group flex w-full items-start justify-end gap-2 py-4',
      from === 'user' ? 'is-user' : 'is-assistant flex-row-reverse justify-end',
      '[&>div]:max-w-[80%]',
      className
    )}
    {...props}
  />
);

export type AIMessageContentProps = HTMLAttributes<HTMLDivElement>;

export const AIMessageContent = ({
  children,
  className,
  ...props
}: AIMessageContentProps) => (
  <div
    className={cn(
      'flex flex-col gap-2 rounded-lg px-4 py-3 text-sm',
      className
    )}
    {...props}
  >
    <div className="is-user:dark">{children}</div>
  </div>
);

export type AIMessageAvatarProps = ComponentProps<typeof Avatar> & {
  src?: string;
  name?: string;
  icon?: ReactNode;
};

export const AIMessageAvatar = ({
  src,
  name,
  icon,
  className,
  ...props
}: AIMessageAvatarProps) => (
  <Avatar className={cn('size-8', className)} {...props}>
    {icon ? (
      <div className="flex h-full w-full items-center justify-center rounded-full bg-muted text-foreground">
        {icon}
      </div>
    ) : (
      <>
        <AvatarImage className="mt-0 mb-0" src={src ?? ''} alt="" />
        <AvatarFallback>{name?.slice(0, 2) || 'ME'}</AvatarFallback>
      </>
    )}
  </Avatar>
);
